import { render } from "./PerformanceChartWh2.vue?vue&type=template&id=1b0ed624&ts=true"
import script from "./PerformanceChartWh2.vue?vue&type=script&lang=ts"
export * from "./PerformanceChartWh2.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__